import { formatFirestoreDate } from "./date_formatter";
import { convertTo12HourFormat } from "./time_formatter";

/**
 * Generates the booking confirmation email HTML template
 * @param {string} bookingId - The booking ID
 * @param {Object} bookingData - The booking data object containing event and customer details
 * @returns {string} - The complete HTML email template
 */
export const getBookingConfirmationEmailTemplate = (bookingId, bookingData) => {
    // Calculate ticket details for the template
    const firstTicketType = Object.keys(bookingData.selectedTickets)[0];
    const firstTicket = bookingData.selectedSlot.tickets.find(t => t.id === firstTicketType);
    const totalTickets = Object.values(bookingData.selectedTickets).reduce((sum, qty) => sum + qty, 0);

    return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>FUSSHN - Ticket Confirmation</title>
    <style>
        @media only screen and (max-width: 600px) {
            .container {
                width: 100% !important;
                max-width: 100% !important;
            }
            .mobile-padding {
                padding: 20px 15px !important;
            }
            .mobile-text-center {
                text-align: center !important;
            }
            .mobile-block {
                display: block !important;
                width: 100% !important;
                text-align: center !important;
            }
            .mobile-stack {
                display: block !important;
                width: 100% !important;
            }
            .mobile-spacing {
                margin-bottom: 20px !important;
            }
            .mobile-header {
                font-size: 28px !important;
                line-height: 1.3 !important;
            }
            .mobile-subheader {
                font-size: 18px !important;
            }
            .mobile-card-padding {
                padding: 20px !important;
            }
            .mobile-event-title {
                font-size: 20px !important;
                line-height: 1.4 !important;
            }
            .mobile-app-buttons {
                display: block !important;
                margin-bottom: 10px !important;
            }
            .mobile-app-buttons div {
                width: 100% !important;
                max-width: 200px !important;
                margin: 0 auto !important;
                justify-content: center !important;
            }
            
            /* App Store Button Hover Effects */
            .app-store-button:hover {
                transform: translateY(-2px) !important;
                box-shadow: 0 6px 12px rgba(0,0,0,0.3) !important;
            }
            
            /* Mobile App Button Adjustments */
            .mobile-app-buttons .app-store-button {
                width: 100% !important;
                max-width: 220px !important;
                margin: 0 auto 15px auto !important;
                display: flex !important;
                justify-content: center !important;
            }
            .mobile-hide-gap {
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
            .mobile-center-text h1 {
                text-align: center !important;
            }
            .mobile-center-text p {
                text-align: center !important;
            }
            .mobile-header-container {
                text-align: center !important;
            }
            .mobile-header-container table {
                margin: 0 auto !important;
                width: 100% !important;
            }
            .mobile-header-container .mobile-block {
                margin: 0 auto !important;
                float: none !important;
                text-align: center !important;
                width: 100% !important;
            }
            .mobile-header-container td {
                text-align: center !important;
                display: block !important;
                width: 100% !important;
                padding-left: 0 !important;
                padding-right: 0 !important;
            }
            .mobile-header-logo {
                margin: 0 auto 15px auto !important;
                text-align: center !important;
            }
            .mobile-header-text {
                text-align: center !important;
                width: 100% !important;
            }
            
            /* Force center alignment for all header elements on mobile */
            .mobile-header-container * {
                text-align: center !important;
            }
            .mobile-header-container table,
            .mobile-header-container tbody,
            .mobile-header-container tr,
            .mobile-header-container td {
                width: 100% !important;
                display: block !important;
                text-align: center !important;
                margin: 0 auto !important;
            }
            .mobile-header-container h1,
            .mobile-header-container p {
                text-align: center !important;
                margin-left: auto !important;
                margin-right: auto !important;
            }
        }
    </style>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #000000; color: #ffffff;">
    <table cellpadding="0" cellspacing="0" border="0" width="100%" style="background-color: #000000;">
        <tr>
            <td align="center" class="mobile-padding" style="padding: 40px 20px;">
                <table cellpadding="0" cellspacing="0" border="0" width="600" class="container" style="max-width: 600px; width: 100%;">
                    
                    <!-- Header Section -->
                    <tr>
                        <td align="center" class="mobile-header-container" style="padding-bottom: 40px;">
                            <table cellpadding="0" cellspacing="0" border="0" class="mobile-block">
                                <tr>
                                    <td class="mobile-block mobile-spacing mobile-header-logo" style="padding-right: 15px; vertical-align: middle;">
                                        <!-- FUSSHN Logo Icon -->
                                        <img src="https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/app_logo%2Fapp_icon.png?alt=media&token=a5953a7e-65fb-4d5e-baa5-1cb5f1723556" alt="FUSSHN Logo" style="width: 60px; height: 60px; border-radius: 12px; display: block; margin: 0 auto;">
                                    </td>
                                    <td class="mobile-block mobile-text-center mobile-center-text mobile-header-text" style="vertical-align: middle;">
                                        <h1 style="margin: 0; font-size: 36px; font-weight: bold; color: #ffffff; letter-spacing: 2px;">FUSSHN</h1>
                                        <p style="margin: 0; font-size: 14px; color: #888888; margin-top: 4px;">Ticket To Covinence</p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    
                    <!-- Main Heading -->
                    <tr>
                        <td align="center" style="padding-bottom: 20px;">
                            <h1 class="mobile-header" style="margin: 0; font-size: 42px; font-weight: bold; color: #ffffff; line-height: 1.2;">Thank you, ${bookingData.ticketDetails.name}!!</h1>
                        </td>
                    </tr>
                    
                    <!-- Subheading -->
                    <tr>
                        <td align="center" style="padding-bottom: 40px;">
                            <p class="mobile-subheader" style="margin: 0; font-size: 20px; color: #888888; line-height: 1.4;">Your ticket is confirmed - Here are the details</p>
                        </td>
                    </tr>
                    
                    <!-- Event Details Card -->
                    <tr>
                        <td style="padding-bottom: 40px;">
                            <table cellpadding="0" cellspacing="0" border="0" width="100%" class="mobile-card-padding" style="background-color: #333333; border-radius: 20px; padding: 30px;">
                                <tr>
                                    <td>
                                        <!-- Event Title -->
                                        <h2 class="mobile-event-title" style="margin: 0 0 30px 0; font-size: 24px; font-weight: bold; color: #ffffff; line-height: 1.3;">${bookingData.eventName}</h2>
                                        
                                        <!-- Booking ID and Event Date Row -->
                                        <table cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-bottom: 20px;">
                                            <tr>
                                                <td width="45%" class="mobile-stack mobile-spacing" style="vertical-align: top; padding-right: 20px;">
                                                    <p style="margin: 0 0 5px 0; font-size: 18px; font-weight: bold; color: #ffffff;">Booking ID</p>
                                                    <p style="margin: 0; font-size: 16px; color: #888888;">${bookingId}</p>
                                                </td>
                                                <td width="10%" class="mobile-hide-gap" style="vertical-align: top;">
                                                    <!-- Spacer for desktop -->
                                                    <span style="display: block; height: 1px;">&nbsp;</span>
                                                </td>
                                                <td width="45%" class="mobile-stack" style="vertical-align: top; padding-left: 20px;">
                                                    <p style="margin: 0 0 5px 0; font-size: 18px; font-weight: bold; color: #ffffff;">Event Date & Time</p>
                                                    <p style="margin: 0; font-size: 16px; color: #888888;">${formatFirestoreDate(bookingData.selectedSlot.startTime)} | ${convertTo12HourFormat(bookingData.selectedSlot.startTime)} - ${convertTo12HourFormat(bookingData.selectedSlot.endTime)}</p>
                                                </td>
                                            </tr>
                                        </table>
                                        
                                        <!-- Venue -->
                                        <div style="margin-bottom: 30px;">
                                            <p style="margin: 0 0 5px 0; font-size: 18px; font-weight: bold; color: #ffffff;">Venue</p>
                                            <p style="margin: 0; font-size: 16px; color: #888888;">${bookingData.eventLocation}</p>
                                        </div>
                                        
                                        <!-- Ticket Details Table -->
                                        <table cellpadding="0" cellspacing="0" border="0" width="100%" style="border-collapse: collapse;">
                                            <tr>
                                                <td style="padding: 12px 0; border-bottom: 1px solid #555555; font-size: 16px; font-weight: bold; color: #ffffff;">Ticket Details</td>
                                                <td style="padding: 12px 0; border-bottom: 1px solid #555555; font-size: 16px; font-weight: bold; color: #ffffff; text-align: center;">Qty</td>
                                                <td style="padding: 12px 0; border-bottom: 1px solid #555555; font-size: 16px; font-weight: bold; color: #ffffff; text-align: center;">Ticket Price</td>
                                                <td style="padding: 12px 0; border-bottom: 1px solid #555555; font-size: 16px; font-weight: bold; color: #ffffff; text-align: center;">Total Price</td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 12px 0; font-size: 16px; color: #888888;">
                                                    ${firstTicket?.name || 'Standard Ticket'}
                                                </td>
                                                <td style="padding: 12px 0; font-size: 16px; color: #888888; text-align: center;">
                                                  ${totalTickets}
                                                </td>
                                                <td style="padding: 12px 0; font-size: 16px; color: #888888; text-align: center;">
                                                  ₹${firstTicket?.price || 0}
                                                </td>
                                                <td style="padding: 12px 0; font-size: 16px; color: #888888; text-align: center;">
                                                  ₹${bookingData.grandTotal}
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    
                    <!-- Download App Section -->
                    <tr>
                        <td align="center" style="padding-bottom: 40px;">
                            <h2 style="margin: 0 0 20px 0; font-size: 24px; font-weight: bold; color: #ffffff;">Download Our App</h2>
                            
                            <table cellpadding="0" cellspacing="0" border="0">
                                <tr>
                                    <td class="mobile-app-buttons" style="padding-right: 10px;">
                                        <a href="https://play.google.com/store/apps/details?id=com.fusshn.fusshncustomer&pcampaignid=web_share" style="text-decoration: none;">
                                            <img src="https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/email-template-icons%2Fgoogle.png?alt=media&token=ee6bf2be-5485-4f50-b490-3a176fed51c6" alt="Get it on Google Play" style="width: 180px; height: 53px; display: block; border-radius: 8px;">
                                        </a>
                                    </td>
                                    <td class="mobile-app-buttons mobile-hide-gap" style="padding-left: 10px;">
                                        <a href="https://apps.apple.com/in/app/fusshn-ticket-to-convenience/id6745167053" style="text-decoration: none;">
                                            <img src="https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/email-template-icons%2Fapple.png?alt=media&token=bb2e1b5d-5733-4f87-b5ac-8004363615a3" alt="Download on the App Store" style="width: 180px; height: 53px; display: block; border-radius: 8px;">
                                        </a>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    
                    <!-- Footer Contact -->
                    <tr>
                        <td align="center" style="padding-bottom: 20px;">
                            <p style="margin: 0; font-size: 16px; color: #888888; line-height: 1.4;">Have any doubts or queries, feel free to contact us at <a href="mailto:fusshn.business@gmail.com" style="color: #888888; text-decoration: underline;">fusshn.business@gmail.com</a></p>
                        </td>
                    </tr>
                    
                    <!-- Social Media Icons -->
                    <tr>
                        <td align="center" style="padding-bottom: 20px;">
                            <table cellpadding="0" cellspacing="0" border="0">
                                <tr>
                                    <td style="padding: 0 10px;">
                                        <a href="https://www.instagram.com/fusshn" style="text-decoration: none;">
                                            <img src="https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/email-template-icons%2Finstagram.png?alt=media&token=8504beeb-c42d-48a1-bbd9-cb7e8233ec0c" alt="Instagram" style="width: 40px; height: 40px; display: block; border-radius: 8px;">
                                        </a>
                                    </td>
                                    <td style="padding: 0 10px;">
                                        <a href="https://www.facebook.com/share/1APxatEANk/" style="text-decoration: none;">
                                            <img src="https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/email-template-icons%2Ffacebook.png?alt=media&token=366eae01-48a0-47df-99dc-fbc49946f8e4" alt="Facebook" style="width: 40px; height: 40px; display: block; border-radius: 8px;">
                                        </a>
                                    </td>
                                    <td style="padding: 0 10px;">
                                        <a href="https://x.com/fusshn_in" style="text-decoration: none;">
                                            <img src="https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/email-template-icons%2Fx.png?alt=media&token=e7e42d9e-1436-4241-b9e5-7288cee66ebe" alt="X (Twitter)" style="width: 40px; height: 40px; display: block; border-radius: 8px;">
                                        </a>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    
                </table>
            </td>
        </tr>
    </table>
</body>
</html>
  `;
};

/**
 * Generates a simple text version of the booking confirmation email
 * @param {string} bookingId - The booking ID
 * @param {Object} bookingData - The booking data object
 * @returns {string} - Plain text email content
 */
export const getBookingConfirmationTextTemplate = (bookingId, bookingData) => {
    const totalTickets = Object.values(bookingData.selectedTickets).reduce((sum, qty) => sum + qty, 0);

    return `
FUSSHN - Booking Confirmed! 🎉

Thank you, ${bookingData.ticketDetails.name}!
Your ticket is confirmed - Here are the details

EVENT DETAILS:
${bookingData.eventName}
${bookingData.eventLocation}
${formatFirestoreDate(bookingData.selectedSlot.startTime)} | ${convertTo12HourFormat(bookingData.selectedSlot.startTime)} - ${convertTo12HourFormat(bookingData.selectedSlot.endTime)}

BOOKING INFORMATION:
Booking ID: ${bookingId}
Total Tickets: ${totalTickets}
Total Amount: ₹${bookingData.grandTotal}

IMPORTANT INSTRUCTIONS:
- Show your ticket QR code at entry
- Bring government ID for verification
- Access tickets from "My Bookings" section in the app

Download Our App:
Google Play: https://play.google.com/store/apps/details?id=com.fusshn.fusshncustomer&pcampaignid=web_share
App Store: https://apps.apple.com/in/app/fusshn-ticket-to-convenience/id6745167053

Contact us: fusshn.business@gmail.com
Follow us:
Instagram: https://www.instagram.com/fusshn
Facebook: https://www.facebook.com/share/1APxatEANk/
X (Twitter): https://x.com/fusshn_in

Thank you for choosing FUSSHN!
  `.trim();
}; 